import { ReferentialValueModel } from './referential-value.model';
import { AttachedFileModel } from './attached-file.model';

/**
 * Created by hbentaher on 23/08/2017.
 */
export class FSKIndexModel {
  public id: number;
  public editorialContentId: number;
  public comments: string;
  public dateIndexing: string;
  public judgement: string;
  public indexingNumber: string;
  public provider: string;
  public publication: string;
  public indexingRuntime: string;
  public sourceData: string;
  public category: ReferentialValueModel;
  public listab: ReferentialValueModel;
  public attachedFiles: AttachedFileModel[];

  constructor() {
    this.category = new ReferentialValueModel();
    this.listab = new ReferentialValueModel();
    this.attachedFiles = [];
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
